import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import AdhocNotificationForm from './AdhocNotificationForm';
import { toast } from 'react-toastify';
import {
  IAdhocNotification,
  IAdhocNotificationSaveRequest,
} from '../business-objects/common';
import { saveAdhocNotification } from '../redux-objects/actions';
import { GetURIByParts } from '../../../services/Utils/StringUtils';

interface IAdhocNotificationActionProps {
  saveAdhocNotification: (
    url: string,
    notification: IAdhocNotificationSaveRequest,
    onSave: () => void
  ) => void;
}
interface IAdhocNotificationStateProps {
  webServiceURL: string;
  cachedAdhocNotification: IAdhocNotification;
}
interface IAdhocNotificationOwnProps {
  reportId?: number;
  occupantId?: number;
  vehicleId?: number;
  onSave?: () => void;
  className?: string;
}
export interface IAdhocNotificationProps
  extends IAdhocNotificationActionProps,
    IAdhocNotificationStateProps,
    IAdhocNotificationOwnProps {}

const initialState = {
  showModal: false,
  adhocNotification: {} as IAdhocNotification,
};

enum ServiceEndPoints {
  SaveAdhocNotification = 'SaveAdhocNotification',
}
type IAdhocNotificationState = Readonly<typeof initialState>;
class AdhocNotificationButton extends React.Component<
  IAdhocNotificationProps,
  IAdhocNotificationState
> {
  public constructor(props: IAdhocNotificationProps) {
    super(props);
    this.state = initialState;
  }
  // toggleScrollLock = () => {
  //   document.querySelector('html').classList.toggle('scroll-lock');
  // };

  closeModal = (e?) => {
    //this.toggleScrollLock();
    this.setState({
      showModal: false,
    });
  };

  private notificationController: string = 'Notification';

  updateNotificationState = (data: IAdhocNotification) => {
    this.setState({ adhocNotification: data });
  };

  onSaveNotification = async (e) => {
    const adhocRequest: IAdhocNotificationSaveRequest = {
      reportId: this.props.reportId,
      vehicleId: this.props.vehicleId,
      occupantId: this.props.occupantId,
      adhocTemplate: this.props.cachedAdhocNotification,
    };

    this.props.saveAdhocNotification(
      GetURIByParts(
        this.props.webServiceURL,
        this.notificationController,
        'SaveAdhocNotification'
      ),
      adhocRequest,
      this.props.onSave
    );
    toast.success('Letter Queued');
    this.closeModal();
    //this.props.onSave();
  };

  showModal = () => {
    this.setState({
      showModal: true,
    });
  };

  public render() {
    return (
      <React.Fragment>
        <Button
          onClick={this.showModal}
          variant='secondary'
          className={this.props.className}
        >
          Custom Letter
        </Button>
        <Modal
          show={this.state.showModal}
          onHide={this.closeModal}
          dialogClassName='modal-notification-template-edit'
        >
          <Modal.Header closeButton>
            <Modal.Title> Custom Letter</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AdhocNotificationForm />
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.closeModal}>
              Close
            </Button>
            <Button variant='primary' onClick={this.onSaveNotification}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    webServiceURL: reduxState.Application.backendURL,
    cachedAdhocNotification: reduxState.Notifications.adhocNotification,
  };
};

const mapDispatchToProps = {
  saveAdhocNotification,
};

export default connect<
  IAdhocNotificationStateProps,
  IAdhocNotificationActionProps
>(
  mapStateToProps,
  mapDispatchToProps
)(AdhocNotificationButton);
